/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import size from 'lodash/fp/size';

import BucketSelect from './BucketSelect';
import { TextField, DateField, ButtonField, CheckboxField } from '@molecules';
import { Form } from '@organisms';
import { Block, ErrorMessage, Typography } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';
import RichTextField from '@molecules/RichTextField';
import MediaField from '@organisms/MediaField';

import { FORM_FIELD } from './constants';

const CampaignForm = ({ initialValues = {}, error, form }) => {
  return (
    <Form form={form} layout="vertical" initialValues={initialValues}>
      <ErrorMessage error={error} variant="block" spaced />
      <Block spaced>
        <TextField {...FORM_FIELD.NAME} />
        <TextField {...FORM_FIELD.TAG} />
        <TextField {...FORM_FIELD.FRIENDLY_NAME} />
        <TextField {...FORM_FIELD.DESCRIPTION} multiline />
        <RichTextField {...FORM_FIELD.THANK_YOU_MESSAGE} />
        <RichTextField {...FORM_FIELD.ALREADY_SIGNED_MESSAGE} />
        <DateField {...FORM_FIELD.CLOSE_DATE} />
        <CheckboxField {...FORM_FIELD.PREFERENCE_CENTRE} style={NO_MARGIN_BOTTOM} />
        <CheckboxField {...FORM_FIELD.SHORT_FORM} />
        <TextField {...FORM_FIELD.REDIRECT_URL} style={!size(initialValues) > 0 && NO_MARGIN_BOTTOM} />
        {size(initialValues) > 0 && <ButtonField {...FORM_FIELD.DOWNLOAD} />}
        <BucketSelect {...FORM_FIELD.BUCKETSELECT} wrapperCol={{ span: 10 }} />
      </Block>
      <Block spaced>
        <Typography.Title level={3} style={{ marginBottom: 40 }}>
          Appearance
        </Typography.Title>
        <MediaField {...FORM_FIELD.HEADER} />
        <MediaField {...FORM_FIELD.BACKGROUND} style={NO_MARGIN_BOTTOM} />
      </Block>
    </Form>
  );
};

CampaignForm.useForm = () => Form.useForm(FORM_FIELD);

export default CampaignForm;
